// extracted by mini-css-extract-plugin
module.exports = {"text-grey":"ConfirmationColumn_text-grey__1T3ra"};